import { RouteObject } from "react-router";

import { ShiftHome } from "./pages";
import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const shiftRoutes: RouteObject[] = [
	{
		path: "shift/*",
		element: (
			<Sentry.ErrorBoundary
				fallback={(fallbackProps) => (
					<PageError
						error={fallbackProps.error}
						componentStack={fallbackProps.componentStack}
						reset={() => fallbackProps.resetError()}
					/>
				)}
			>
				<ShiftHome />
			</Sentry.ErrorBoundary>
		),
	},
];
